module.exports = __webpack_public_path__ + "static/media/m1cr64.00db244f.png";